import React from "react";
import PageWrapper from "./viewClient.style";
import PageTitle from "components/common/PageTitle";
import { connect } from "react-redux";
import ViewClientTable from "../../components/viewclient/ViewClientTable";

const ViewClient = props => {
  return (
    <PageWrapper {...props}>
      <PageTitle
        props={props}
        title="sidebar.client_management"
        className="plr-15"
        breadCrumb={[
          {
            name: "sidebar.dashboard",
            url: "/client"
          },
          {
            name: "sidebar.client_management"
          }
        ]}
      />
      <div className="user-tbl">
        <ViewClientTable {...props} />
      </div>
    </PageWrapper>
  );
};

const mapStateToProps = state => {
  return {
    ...state.themeChanger,
    ...state.permissionReducer,
    auth: state.auth,
    authData: {
      token: state.auth.token,
      isLogin: state.auth.isLogin,
      profileImage: state.auth.profile_image,
      adminRoleId: state.auth.admin_role_id,
      adminRole: state.auth.admin_role,
      full_name: state.auth.first_name + " " + state.auth.last_name
    }
  };
};

export default connect(mapStateToProps, null)(ViewClient);
